export default __webpack_public_path__ + "static/media/014-wales.3034cc84.svg";